export default (a, b) => {
  if (!a && !b) {
      return true;
    }
    else if (a && b && a.id === b.id){
      return true;
    }
    else if (!a || !b) {
      return false;
    }
};
